import { PageContent, Box, Heading, Paragraph, } from "grommet";
import Whew from "../images/whew.png";
import { CaseyImage } from "./casey-image";
export const AppFooter = (props: any) => {
    return (
        <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal_constant' }} pad="xlarge" style={{ paddingTop: "24px", paddingBottom: "24px" }}>
            <Box align="center">
                <Heading style={{ WebkitTextStroke: "0.3px rgba(34, 34, 34, 1)" }} weight="normal" size="44px" margin="medium" color="green_foreground" textAlign="center">
                    10 years down... 10 to go!
                </Heading>
                <CaseyImage
                    src={Whew}
                    style={{ width: "200px" }}
                    alignSelf="center"
                    margin="xsmall"
                />

                <Paragraph color="green_foreground" textAlign="center">
                    (this is a joke)
                </Paragraph>

                <Paragraph color="green_foreground" textAlign="center">
                    (not the marriage part, that part is real)
                </Paragraph>
            </Box>
        </PageContent>);
};